var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 506,
    height: 226,
    viewBox: "0 0 506 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3545_444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M489.693 43.3804H43.9123C34.9061 43.3804 27.6057 50.6817 27.6057 59.6891V154.232C31.2914 157.654 34.7741 161.313 38.052 165.154C43.5282 170.649 48.4194 176.689 53.4051 182.622H489.693C498.7 182.622 506 175.32 506 166.313V59.6891C506 50.6817 498.7 43.3804 489.693 43.3804Z",
    fill: "url(#paint0_linear_3545_444)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.315 46.1641H43.481C36.2515 46.1641 30.3892 52.0252 30.3892 59.2576V156.897C33.0564 159.533 35.6094 162.294 38.05 165.154C42.6713 169.792 46.875 174.816 51.0728 179.838H490.125C497.354 179.838 503.217 173.977 503.217 166.744V58.0676C503.217 51.4933 497.888 46.1641 491.315 46.1641Z",
    fill: "url(#paint1_linear_3545_444)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.179 51.064H44.4265C39.4053 51.064 35.3336 55.1362 35.3336 60.1581V162.065C36.2535 163.082 37.1616 164.11 38.052 165.152C41.1663 168.277 44.0896 171.579 46.9518 174.936H489.181C494.203 174.936 498.274 170.864 498.274 165.842V60.1581C498.274 55.1362 494.203 51.064 489.181 51.064H489.179Z",
    fill: "url(#paint2_linear_3545_444)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3976 223.275C84.5389 217.609 70.6474 209.047 58.1072 197.823C46.1107 187.088 35.6034 174.144 26.8749 159.352C18.2626 144.758 11.5789 128.697 7.01273 111.62C2.3599 94.2197 0 76.1043 0 57.7781C0 48.4279 0.632328 38.9732 1.88122 29.6761L5.05074 6.07983L27.7673 13.1979C36.086 15.8044 44.7495 17.1264 53.5213 17.1264C68.4726 17.1264 83.3845 13.1487 96.6437 5.62276L106.548 0L116.453 5.62473C116.598 5.70748 116.746 5.78628 116.894 5.86509L116.941 5.8907C117.15 6.003 117.361 6.11727 117.57 6.23153C130.549 13.3595 145.073 17.1264 159.573 17.1264C168.345 17.1264 177.008 15.8044 185.325 13.1979L208.042 6.07786L211.211 29.6742C212.46 38.9712 213.092 48.4259 213.092 57.7762C213.092 75.9388 210.774 93.8986 206.202 111.157C201.714 128.094 195.145 144.044 186.677 158.562C178.1 173.265 167.766 186.176 155.96 196.931C143.633 208.162 129.962 216.809 115.326 222.629L114.967 222.771C114.552 222.936 114.124 223.108 113.693 223.271L106.542 225.996L99.3956 223.271L99.3976 223.275Z",
    fill: "url(#paint3_linear_3545_444)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.163 210.775C90.8385 205.694 78.3436 197.983 67.0268 187.852C56.0566 178.033 46.4219 166.157 38.3927 152.551C30.3971 139.003 24.1861 124.069 19.9331 108.162C15.5817 91.889 13.3754 74.938 13.3754 57.7781C13.3754 49.0209 13.9684 40.1651 15.1385 31.4571L16.1943 23.5924L23.7665 25.9644C33.3794 28.9767 43.3903 30.5036 53.5194 30.5036C70.7813 30.5036 87.9763 25.923 103.245 17.2564L106.546 15.3828L109.848 17.2584C110.092 17.3983 110.34 17.5303 110.588 17.6642C110.77 17.7627 110.951 17.8593 111.132 17.9597C126.077 26.1654 142.827 30.5036 159.571 30.5036C169.7 30.5036 179.711 28.9767 189.322 25.9644L196.894 23.5904L197.95 31.4552C199.12 40.1632 199.713 49.0189 199.713 57.7762C199.713 74.7824 197.546 91.5876 193.27 107.729C189.092 123.506 182.985 138.339 175.121 151.819C167.228 165.349 157.751 177.198 146.95 187.041C135.818 197.185 123.517 204.975 110.384 210.196L110.007 210.345C109.647 210.489 109.288 210.633 108.926 210.771L106.544 211.679L104.163 210.771V210.775Z",
    fill: "url(#paint4_linear_3545_444)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.323 32.3476C181.051 35.5668 170.413 37.1942 159.571 37.1942C141.58 37.1942 123.863 32.5821 107.913 23.8248C107.458 23.5746 106.997 23.3343 106.544 23.0762C90.2436 32.3279 72.0243 37.1942 53.5194 37.1942C42.6772 37.1942 32.038 35.5668 21.7671 32.3476C20.6364 40.7759 20.0651 49.2927 20.0651 57.7781C20.0651 125.253 55.4735 185.051 106.546 204.524C107.005 204.348 107.458 204.163 107.915 203.982C158.249 183.967 193.027 124.646 193.027 57.7761C193.027 49.2868 192.456 40.7699 191.325 32.3457L191.323 32.3476Z",
    fill: "url(#paint5_linear_3545_444)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.815 48.4216L182.376 15.085L98.5683 121.915L58.3239 71.417L30.3025 87.6785L98.8283 162.926L230.815 48.4216Z",
    fill: "url(#paint6_linear_3545_444)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.465 13.9443L182.376 15.085L230.815 48.4217L247.904 47.2829L199.465 13.9443Z",
    fill: "url(#paint7_linear_3545_444)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4125 70.2783L58.3239 71.4171L98.5683 121.916L107.496 110.534L75.4125 70.2783Z",
    fill: "url(#paint8_linear_3545_444)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8283 162.926L115.917 161.785L247.904 47.2832L230.815 48.4219L98.8283 162.926Z",
    fill: "url(#paint9_linear_3545_444)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.986 161.068H237.544V124.745H252.572C256.65 124.745 259.774 125.805 261.941 127.925C264.11 130.045 265.193 133.032 265.193 136.885C265.193 140.739 264.11 143.725 261.941 145.845C259.774 147.965 256.65 149.025 252.572 149.025H246.986V161.068ZM246.986 141.412H250.116C253.585 141.412 255.318 139.903 255.318 136.883C255.318 133.863 253.585 132.354 250.116 132.354H246.986V141.41V141.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.435 154.759H276.948L274.781 161.069H264.715L278.539 124.746H288.848L302.672 161.069H292.606L290.439 154.759H290.435ZM287.93 147.581L283.691 135.489L279.451 147.581H287.93Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.159 143.629L298.914 124.746H310.185L316.928 134.669L323.624 124.746H334.895L321.601 143.629V161.069H312.159V143.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.58 161.069L342.745 124.746H352.09L359.363 144.112L366.588 124.746H375.934L382.099 161.069H372.707L369.577 140.162L361.004 161.069H357.247L349.108 140.162L345.978 161.069H336.585H336.58Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.736 132.742H397.511V138.812H408.109V146.809H397.511V153.072H408.736V161.069H388.072V124.746H408.736V132.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.526 161.069V124.746H424.967L442.405 146.955V124.746H451.797V161.069H442.405L424.967 138.86V161.069H415.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.184 132.742V161.069H463.742V132.742H455.987V124.746H480.937V132.742H473.182H473.184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.721 78.3935C264.38 77.304 263.036 76.4963 261.697 75.9722C260.355 75.4482 259.055 75.1861 257.798 75.1861C256.205 75.1861 254.905 75.5644 253.9 76.319C252.893 77.0735 252.391 78.0586 252.391 79.2761C252.391 80.1154 252.643 80.8069 253.146 81.3527C253.648 81.8984 254.308 82.3692 255.127 82.7672C255.945 83.1672 256.867 83.5119 257.895 83.8055C258.921 84.099 259.94 84.4143 260.944 84.7492C264.969 86.0908 267.914 87.8837 269.781 90.1276C271.647 92.3716 272.58 95.2973 272.58 98.9026C272.58 101.336 272.171 103.536 271.353 105.507C270.536 107.479 269.34 109.165 267.768 110.57C266.196 111.974 264.266 113.066 261.982 113.84C259.697 114.616 257.109 115.005 254.215 115.005C248.219 115.005 242.664 113.224 237.548 109.658L242.831 99.7183C244.675 101.353 246.499 102.571 248.304 103.367C250.106 104.165 251.889 104.563 253.65 104.563C255.663 104.563 257.16 104.102 258.147 103.18C259.132 102.258 259.625 101.21 259.625 100.035C259.625 99.3223 259.498 98.7036 259.246 98.1796C258.994 97.6555 258.575 97.1728 257.99 96.7335C257.403 96.2942 256.636 95.8844 255.695 95.5061C254.751 95.1298 253.609 94.7102 252.267 94.2492C250.673 93.7448 249.111 93.1912 247.581 92.5824C246.05 91.9756 244.687 91.1679 243.493 90.1611C242.298 89.1544 241.334 87.8876 240.6 86.3548C239.865 84.824 239.498 82.8854 239.498 80.537C239.498 78.1886 239.886 76.0609 240.663 74.1518C241.439 72.2447 242.528 70.6095 243.933 69.2462C245.337 67.8848 247.055 66.8249 249.09 66.0703C251.123 65.3158 253.398 64.9375 255.913 64.9375C258.261 64.9375 260.714 65.2626 263.271 65.9127C265.828 66.5629 268.28 67.5164 270.63 68.7753L265.725 78.3994L265.721 78.3935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.293 76.6951H292.639V84.621H306.476V95.0627H292.639V103.241H307.293V113.682H280.312V66.2554H307.293V76.6971V76.6951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.311 82.1033C347.459 78.6241 343.939 76.8825 339.745 76.8825C337.899 76.8825 336.191 77.2194 334.619 77.8892C333.047 78.561 331.694 79.4732 330.563 80.6257C329.431 81.7802 328.54 83.1514 327.89 84.7453C327.24 86.3391 326.915 88.059 326.915 89.9031C326.915 91.7471 327.24 93.5301 327.89 95.1239C328.54 96.7178 329.441 98.1028 330.595 99.275C331.747 100.449 333.101 101.373 334.651 102.043C336.201 102.715 337.879 103.05 339.682 103.05C343.624 103.05 347.165 101.373 350.311 98.0181V112.611L349.055 113.052C347.167 113.722 345.406 114.215 343.771 114.53C342.136 114.845 340.521 115.003 338.929 115.003C335.659 115.003 332.523 114.384 329.527 113.147C326.529 111.909 323.887 110.17 321.602 107.926C319.317 105.682 317.483 103.02 316.099 99.937C314.716 96.8557 314.022 93.4887 314.022 89.842C314.022 86.1953 314.704 82.85 316.067 79.8101C317.428 76.7702 319.252 74.1499 321.539 71.9473C323.824 69.7466 326.476 68.0267 329.496 66.7895C332.516 65.5522 335.679 64.9336 338.992 64.9336C340.88 64.9336 342.735 65.1326 344.557 65.5305C346.381 65.9305 348.3 66.5471 350.311 67.3864V82.1053V82.1033Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.437 66.2534V92.0425C370.437 93.4255 370.489 94.842 370.595 96.2881C370.699 97.7342 371.015 99.0463 371.539 100.219C372.063 101.393 372.892 102.348 374.023 103.081C375.155 103.816 376.747 104.182 378.801 104.182C380.856 104.182 382.438 103.816 383.549 103.081C384.66 102.348 385.487 101.393 386.033 100.219C386.577 99.0443 386.904 97.7342 387.008 96.2881C387.112 94.842 387.166 93.4255 387.166 92.0425V66.2534H399.43V93.7407C399.43 101.123 397.742 106.509 394.367 109.906C390.993 113.302 385.802 115 378.801 115C371.801 115 366.6 113.302 363.204 109.906C359.808 106.509 358.11 101.121 358.11 93.7407V66.2534H370.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.801 113.68H433.455L421.693 95.439V113.68H409.366V66.2534H428.549C431.19 66.2534 433.495 66.6415 435.467 67.4178C437.437 68.194 439.062 69.252 440.34 70.5936C441.619 71.9353 442.582 73.4878 443.234 75.2491C443.884 77.0104 444.209 78.8977 444.209 80.9092C444.209 84.5166 443.338 87.4422 441.599 89.6842C439.86 91.9282 437.291 93.4491 433.895 94.2451L448.801 113.68ZM421.693 87.4501H424.02C426.451 87.4501 428.318 86.9457 429.616 85.941C430.916 84.9342 431.566 83.4881 431.566 81.6008C431.566 79.7134 430.916 78.2673 429.616 77.2606C428.316 76.2538 426.451 75.7514 424.02 75.7514H421.693V87.4521V87.4501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.939 76.6951H466.285V84.621H480.122V95.0627H466.285V103.241H480.939V113.682H453.958V66.2554H480.939V76.6971V76.6951Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3545_444",
    x1: 22.8564,
    y1: 113.001,
    x2: 517.254,
    y2: 113.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DCC25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#279436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3545_444",
    x1: 25.695,
    y1: -0.000113171,
    x2: 514.339,
    y2: -0.000113171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DCC25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#279436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3545_444",
    x1: 266.803,
    y1: 49.3657,
    x2: 266.803,
    y2: 179.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#398017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14481A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3545_444",
    x1: 53.5056,
    y1: -25.2867,
    x2: 180.84,
    y2: 189.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7D63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9ED33F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39B54A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3545_444",
    x1: 106.341,
    y1: 10.7175,
    x2: 107.242,
    y2: 219.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#9ED33F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7D63F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3545_444",
    x1: 106.546,
    y1: 23.0762,
    x2: 106.546,
    y2: 204.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#285910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09210C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3545_444",
    x1: 81.2196,
    y1: 156.399,
    x2: 166.706,
    y2: 3.36462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7D63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9ED33F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39B54A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3545_444",
    x1: 189.294,
    y1: 11.9112,
    x2: 240.203,
    y2: 49.8612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7D63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9ED33F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39B54A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3545_444",
    x1: 65.9472,
    y1: 67.8511,
    x2: 104.116,
    y2: 119.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FAD1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20782C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3545_444",
    x1: 239.979,
    y1: 45.0294,
    x2: 107.251,
    y2: 164.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20782C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FAD1F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3545_444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 506,
    height: 226,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.ec72b431725bcdc2dd0b6694d2b82e7e.svg";
export { ForwardRef as ReactComponent };